import styled from "styled-components";
import { Colors } from "@/common/colors/colors";

export const WrapperBox = styled.div`
	display: flex;
	align-items: center;
	margin: 30px;
	gap: 30px;
`;

export const ItemsTitle = styled.p`
	font-weight: bold;
	font-size: 18px;
	color: ${Colors.darkBlue};
	width: 150px;
`;

export const Splitter = styled.div`
	width: 100%;
	height: 2px;
	background-color: ${Colors.darkGray};
	margin: 18px 0;
`;

export const AdditionalInfoWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;
    text-align: left;
`

export const AdditionalInfoItem = styled.div`								
	cursor: pointer;
	background: ${Colors.green};
	padding: 5px;
	color: white;
	text-align: center;
	border-radius: 10px;
`

export const InfoValue = styled.p`
    font-size: 15px;
`

export const OptionsContainer = styled.div`
	display: flex;
`

export const InputsContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 10px;
`

export const Title = styled.h3`
	color: ${Colors.darkBlue};
    margin-bottom: 20px;
`;
